export default function getLocalStorageObject<T>(key: string, defaultValue?: T) {
  try {
    const item = window.localStorage.getItem(key);
    return !!item ? JSON.parse(item) || defaultValue : defaultValue;
  } catch (error) {
    return defaultValue;
  }
}
